import { graphql } from '@/gql';
import type { CheckAndRecordGourmetPopupMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const checkAndRecordGourmetPopup = async ({
  phoneNumber,
  locations,
}: CheckAndRecordGourmetPopupMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CheckAndRecordGourmetPopup($phoneNumber: String!, $locations: [CoordinatesInput!]!) {
        checkAndRecordGourmetPopup(phoneNumber: $phoneNumber, locations: $locations)
      }
    `),
    variables: {
      phoneNumber,
      locations,
    },
  });

  return response.data?.checkAndRecordGourmetPopup ?? false;
};
